import { call, fork, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Delete cargo name
 * */
function* getCargoRealNames() {
    try {
        const response = yield call(api.getCargoRealNames);

        if (response.status === 200) {
            yield put({
                type: actionTypes.GET_CARGO_REAL_NAMES.SUCCESS,
                data: response.data,
            });
            return;
        }

        yield put({
            type: actionTypes.GET_CARGO_REAL_NAMES.FAILURE,
            errors: response.errors,
        });
    } catch (e) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Error',
                message: 'Something went wrong',
                level: 'error',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });
    }
}

export function* watchGetCargoRealNames() {
    while (true) {
        yield take(actionTypes.GET_CARGO_REAL_NAMES.REQUEST);
        yield fork(getCargoRealNames);
    }
}

/**
 * Delete cargo name
 * */
function* updateCargoRealName(item) {
    try {
        const response = yield call(api.updateCargoRealName, item);

        if (response.status === 200) {
            yield put({
                type: actionTypes.UPDATE_CARGO_REAL_NAME.SUCCESS,
                item,
            });

            yield put({
                type: actionTypes.ADD_NOTIFICATION,
                notification: {
                    title: 'Success',
                    message: `${item.name} updated`,
                    level: 'success',
                    _id: item._id,
                    autoDismiss: 2,
                },
            });
            return;
        }

        yield put({
            type: actionTypes.UPDATE_CARGO_REAL_NAME.FAILURE,
            item,
            error: response.errors,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Error',
                message: response.errors[0].messages[0],
                level: 'error',
                _id: item._id,
                autoDismiss: 2,
            },
        });
    } catch (error) {
        console.error(error);
    }
}

export function* watchUpdateCargoRealName() {
    while (true) {
        const { item } = yield take(actionTypes.UPDATE_CARGO_REAL_NAME.REQUEST);
        yield fork(updateCargoRealName, item);
    }
}

/**
 * Delete cargo name
 * */
function* deleteCargoRealName(item) {
    const response = yield call(api.deleteCargoRealName, item);
    if (response.status === 200) {
        yield put({
            type: actionTypes.DELETE_CARGO_REAL_NAME.SUCCESS,
            item,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `${item.name} updated`,
                level: 'success',
                _id: response.data._id,
                autoDismiss: 2,
            },
        });

        return;
    }

    yield put({
        type: actionTypes.DELETE_CARGO_REAL_NAME.FAILURE,
        item,
        error: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: item._id,
            autoDismiss: 2,
        },
    });
}

export function* watchDeleteCargoRealName() {
    while (true) {
        const { item } = yield take(actionTypes.DELETE_CARGO_REAL_NAME.REQUEST);
        yield fork(deleteCargoRealName, item);
    }
}

function* getCargoRealNamesPaginated(opts) {
    try {
        const response = yield call(api.getCargoRealNamesPaginated, opts);

        if (response && (!response.errors || !response.errors.length)) {
            yield put({
                type: actionTypes.GET_CARGO_REAL_NAMES_PAGINATED.SUCCESS,
                data: response.data,
            });
            return;
        }

        yield put({
            type: actionTypes.GET_CARGO_REAL_NAMES_PAGINATED.FAILURE,
            errors: response.errors,
        });
    } catch (e) {
        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Error',
                message: 'Something went wrong',
                level: 'error',
                _id: new Date().getMilliseconds(),
                autoDismiss: 2,
            },
        });
    }
}

export function* watchGetCargoRealNamesPaginated() {
    while (true) {
        const { opts } = yield take(actionTypes.GET_CARGO_REAL_NAMES_PAGINATED.REQUEST);
        yield fork(getCargoRealNamesPaginated, opts);
    }
}

export default [
    watchUpdateCargoRealName,
    watchGetCargoRealNames,
    watchDeleteCargoRealName,
    watchGetCargoRealNamesPaginated,
];



// WEBPACK FOOTER //
// ./app/sagas/cargoes/realNames.js